import { supabase } from "../../data/supabase/client";
import {
  SubmitJobResponse,
  WeeklyCoachingReportParameters
} from "./types";

export type {
  BackgroundJob,
  BackgroundJobStatus,
  BackgroundJobType,
  SubmitJobResponse,
  WeeklyCoachingReportParameters
} from "./types";

export {
  DOCUMENT_NAME_AGENT_SCORECARDS_SUMMARY,
  DOCUMENT_NAME_TEAM_BENCHMARKS
} from "./types";

const FUNCTION = "background-jobs";

interface InvokeError {
  message: string;
}

const invokeFunction = async <T>(body: Record<string, unknown>): Promise<T> => {
  const { data, error } = await supabase.functions.invoke(FUNCTION, { body });
  if (error) {
    const message = (error as InvokeError).message ?? "background-jobs invocation failed";
    throw new Error(message);
  }
  return data as T;
};

export interface SubmitWeeklyCoachingReportInput {
  parameters: WeeklyCoachingReportParameters;
}

export const submitWeeklyCoachingReport = async (
  input: SubmitWeeklyCoachingReportInput
): Promise<SubmitJobResponse> =>
  invokeFunction<SubmitJobResponse>({
    action: "submit",
    job_type: "weekly_coaching_report",
    parameters: input.parameters
  });

export const cancelJob = async (jobId: string, tenantId: string): Promise<{ success: boolean }> =>
  invokeFunction<{ success: boolean }>({
    action: "cancel",
    job_id: jobId,
    tenant_id: tenantId
  });
